import {AnalyticsVisualizationAggregationType as AggregationType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {assertNever} from 'util/Types';

export default function getAggregatedAxisName(
  aggregationType: AggregationType | null,
  axisName: string
): string {
  switch (aggregationType) {
    case AggregationType.COUNT:
      return `Count ${axisName}`;
    case AggregationType.MEAN:
      return `Mean ${axisName}`;
    case AggregationType.SUM:
      return `Sum ${axisName}`;
    case null:
      return axisName;
    default:
      throw new Error(`Unsupported aggregation type ${assertNever(aggregationType)}`);
  }
}
